import React, { useState } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Button,
  Linking,
  Image} from "react-native";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow} from "@react-google-maps/api";
import PropertyMapsMobileStyle from "../PropertyMapMobile/PropertyMapsMobileStyle";
import PropertyMapsStyle from "./PropertyMapsStyle";
import PropertyDetailsStyle from "../../Investment/Properties/PropertyDetailsStyle";
import OverflowTooltipText from "../../../components/OverflowTooltipText";
import FormattedText from "../../../components/FormattedText";
import commonStyles from "../../../styles/commonStyles";
import AppText from "../../../components/AppText";

const PropertyMap: React.FC<any> = ({ property }: { property: any[] }) => {
  const containerStyle = {
    width: "100%",
    height: "700px"};

  const center = {
    lat: 33.584902474476664,
    lng: -102.02108799999999};

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBDc4-mt4j8XebGWbbf4LUeDlXMht69Qc8"});

  const [activeMarker, setActiveMarker] = useState<string | null>(null);

  const handleMarkerClick = (markerId: string) => {
    if (markerId === activeMarker) {
      setActiveMarker(null);
    } else {
      setActiveMarker(markerId);
    }
  };

  if (!isLoaded) return <View style={[commonStyles.flexCenter, commonStyles.fH]}>Loading...</View>;

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={5}>
      {property.map((marker, index) => (
        <Marker
          key={`${marker.id}-${index}-${Date.now()}`}
          position={{
            lat: Number(marker.latitude),
            lng: Number(marker.longitude)}}
          title={marker.name}
          onClick={() => handleMarkerClick(marker.id)}
        >
          {activeMarker === marker.id && (
            <InfoWindow
              onCloseClick={() => setActiveMarker(null)}
              position={{
                lat: Number(marker.latitude),
                lng: Number(marker.longitude)}}
            >
              <View style={PropertyMapsStyle.infoWindowContainer}>
                <View style={PropertyMapsMobileStyle.table}>
                  <View style={[PropertyMapsMobileStyle.tableRow]}>
                    <AppText style={PropertyDetailsStyle.title}>
                      Property Name
                    </AppText>
                    <OverflowTooltipText
                      text={marker.name}
                      style={PropertyDetailsStyle.value}
                      containerWidth="40%"
                    />
                  </View>
                  <View style={[PropertyMapsMobileStyle.tableRow]}>
                    <AppText style={PropertyDetailsStyle.title}>Total Acres</AppText>

                    <FormattedText
                      value={marker.totalAcres}
                      type="number"
                      style={PropertyDetailsStyle.value}
                    />
                  </View>
                  <View style={[PropertyMapsMobileStyle.tableRow]}>
                    <AppText style={PropertyDetailsStyle.title}>Your Acres</AppText>

                    <FormattedText
                      value={marker.yourAcres}
                      type="number"
                      style={PropertyDetailsStyle.value}
                    />
                  </View>
                  {marker.remainingAcres != marker.yourAcres ? (
                    <View style={[PropertyMapsMobileStyle.tableRow]}>
                      <AppText style={PropertyDetailsStyle.title}>
                        Remaining Acres
                      </AppText>

                      <FormattedText
                        value={marker.remainingAcres}
                        type="number"
                        style={PropertyDetailsStyle.value}
                      />
                    </View>
                  ) : (
                    ""
                  )}
                  <View style={[PropertyMapsMobileStyle.tableRow]}>
                    <AppText style={PropertyDetailsStyle.title}>Documents</AppText>
                    {marker.documentsURL ? (
                      <AppText
                        style={PropertyDetailsStyle.link}
                        onPress={() => Linking.openURL(marker.documentsURL)}
                      >
                        View
                      </AppText>
                    ) : (
                      <AppText style={PropertyDetailsStyle.value}>N/A</AppText>
                    )}
                  </View>
                  <View style={[PropertyMapsMobileStyle.tableRow]}>
                    <AppText style={PropertyDetailsStyle.title}>Location</AppText>
                    {marker.documentsURL ? (
                      <AppText
                        style={PropertyDetailsStyle.link}
                        onPress={() =>
                          Linking.openURL(marker.googleEarthLocation)
                        }
                      >
                        View
                      </AppText>
                    ) : (
                      <AppText style={PropertyDetailsStyle.value}>N/A</AppText>
                    )}
                  </View>
                </View>
              </View>
            </InfoWindow>
          )}
        </Marker>
      ))}
    </GoogleMap>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1},
  map: {
    width: "100%",
    height: "100%"}});

export default PropertyMap;
